/** GlobalBanner keys */
const CLOSEOUT_NOTIFICATION_BANNER = 'CLOSEOUT_NOTIFICATION_BANNER';
const PROJECTS_MIGRATED_BANNER = 'PROJECTS_MIGRATED_BANNER';
const GENERIC_TEXT_BANNER = 'GENERIC_TEXT_BANNER';
const MOBILE_OFFLINE_BANNER = 'MOBILE_OFFLINE_BANNER';
const MOBILE_BAD_CONNECTION = 'MOBILE_BAD_CONNECTION';
const SYNC_SUCCESSFUL_BANNER = 'SYNC_SUCCESSFUL_BANNER';
const ANNOUNCEMENT_BANNER = 'ANNOUNCEMENT_BANNER';

/** GlobalModal keys */
const FEATURE_WALKTHROUGH = 'FEATURE_WALKTHROUGH';
const FILE_UPLOADER = 'FILE_UPLOADER';
const NOTIFICATIONS_ANNOUNCEMENT_MODAL = 'NOTIFICATIONS_ANNOUNCEMENT_MODAL';
const MOBILE_FILES_ANNOUNCEMENT_MODAL = 'MOBILE_FILES_ANNOUNCEMENT_MODAL';
const SYSTEM_POPUP = 'SYSTEM_POPUP'; //TODO: replace 50+ uses of this string with constant
const TEMPLATE_PUBLISH_MODAL = 'TEMPLATE_PUBLISH_MODAL';
const USER_SETTINGS_MODAL = 'USER_SETTINGS_MODAL';
const NOTIFICATIONS_ANNOUNCEMENT_CIRCLE_ANNOUNCEMENT = 'NOTIFICATIONS_ANNOUNCEMENT_CIRCLE_ANNOUNCEMENT';
const DELAYS_ANNOUNCEMENT_CIRCLE_ANNOUNCEMENT = 'DELAYS_ANNOUNCEMENT_CIRCLE_ANNOUNCEMENT';
const DELAYS_ANNOUNCEMENT_CIRCLE_ANNOUNCEMENT_MULTIPLE  = 'DELAYS_ANNOUNCEMENT_CIRCLE_ANNOUNCEMENT_MULTIPLE';
const HANDSFREE_ERROR_MODAL = 'HANDSFREE_ERROR_MODAL';
const ZIP_DOWNLOAD_NOTIFICATION_BANNER = 'ZIP_DOWNLOAD_NOTIFICATION_BANNER';
const KMZ_DOWNLOAD_NOTIFICATION_BANNER = 'KMZ_DOWNLOAD_NOTIFICATION_BANNER';

export default {
  CLOSEOUT_NOTIFICATION_BANNER,
  PROJECTS_MIGRATED_BANNER,
  GENERIC_TEXT_BANNER,
  MOBILE_OFFLINE_BANNER,
  MOBILE_BAD_CONNECTION,
  SYNC_SUCCESSFUL_BANNER,
  ANNOUNCEMENT_BANNER,
  ZIP_DOWNLOAD_NOTIFICATION_BANNER,
  KMZ_DOWNLOAD_NOTIFICATION_BANNER,
  FEATURE_WALKTHROUGH,
  FILE_UPLOADER,
  NOTIFICATIONS_ANNOUNCEMENT_MODAL,
  MOBILE_FILES_ANNOUNCEMENT_MODAL,
  SYSTEM_POPUP,
  TEMPLATE_PUBLISH_MODAL,
  USER_SETTINGS_MODAL,
  NOTIFICATIONS_ANNOUNCEMENT_CIRCLE_ANNOUNCEMENT,
  DELAYS_ANNOUNCEMENT_CIRCLE_ANNOUNCEMENT,
  DELAYS_ANNOUNCEMENT_CIRCLE_ANNOUNCEMENT_MULTIPLE,
  HANDSFREE_ERROR_MODAL,
};



// WEBPACK FOOTER //
// ./src/constants/ModalBannerConstants.js